import { useEffect, useRef } from 'react'
import { track } from './events'
import type { ModalClosedBy } from './types'

interface UseModalTrackingParams {
  open: boolean
  modalType: string
  closedBy?: ModalClosedBy
}

export function useModalTracking({ open, modalType, closedBy }: UseModalTrackingParams): void {
  const openTimestampRef = useRef<number | null>(null)
  const wasOpenRef = useRef(false)
  const modalTypeRef = useRef(modalType)
  const closedByRef = useRef(closedBy)

  modalTypeRef.current = modalType
  closedByRef.current = closedBy

  useEffect(() => {
    if (open && !wasOpenRef.current) {
      openTimestampRef.current = Date.now()
      track('modal_opened', { modal_type: modalType })
    } else if (!open && wasOpenRef.current && openTimestampRef.current !== null) {
      const duration = Date.now() - openTimestampRef.current
      track('modal_closed', {
        modal_type: modalType,
        duration_ms: duration,
        closed_by: closedBy ?? 'user',
      })
      openTimestampRef.current = null
    }
    wasOpenRef.current = open
  }, [open, modalType, closedBy])

  useEffect(() => {
    return () => {
      if (wasOpenRef.current && openTimestampRef.current !== null) {
        const duration = Date.now() - openTimestampRef.current
        track('modal_closed', {
          modal_type: modalTypeRef.current,
          duration_ms: duration,
          closed_by: 'navigation',
        })
      }
    }
  }, [])
}
